<script setup>
import { onMounted, reactive } from 'vue'
import { Inertia } from '@inertiajs/inertia'
import { useStore } from '@/store/bucket'
import stripslashes, { replaceS3path, addBR } from '@/Shared/helper.js'
import ButtonRounded from '@/Shared/Buttons/ButtonRounded'
import ButtonFavoriteToggle from '@/Shared/Buttons/ButtonFavoriteToggle'
import useFavorites from '@/Shared/useFavorites.js'
import Modal from '@/Shared/Modal/Modal'

const props = defineProps({
  category: String,
  categoryJ: String,
})

const favorite = reactive({
  favorites: [],
})

const modal = reactive({ open: false })
const openModal = (id, category) => {
  useStore().updateModal({ id: id, category: category })
  modal.open = true
}

const emit = defineEmits(['change'])
const { sortFavoriteList, subscribeFavoriteList } = useFavorites({ favorite: favorite, category: props.category })
onMounted(() => {
  sortFavoriteList()
  subscribeFavoriteList(sortFavoriteList)

  Inertia.on('start', () => {
    modal.open = false
  })
})
</script>

<template>
  <div class="absolute top-0 w-full h-[calc(100dvh_-_192px)] sm:h-[calc(100dvh_-_235px)] overflow-y-scroll scrollbar-hidden">
    <template v-if="!favorite.favorites.length">
      <p class="mt-[60px] mb-[50px] text-center text-[15px] font-medium leading-[2]">
        お気に入りの{{ props.categoryJ }}はありません。<br />
        気になる{{ props.categoryJ }}を是非追加してください。
      </p>
    </template>

    <template v-else>
      <ul class="flex flex-wrap p-[15px] sm:p-[20px]">
        <template v-if="props.category === 'brand'">
          <li v-for="item in favorite.favorites" :key="item.brandID" class="relative w-1/2 aspect-square p-[10px] transition-all duration-300">
            <a class="flex items-center justify-center p-[30px] w-full h-full border border-dotted border-[#bbb] rounded-[20px]" href="#" @click.prevent="openModal(item.brandID, 'brand')">
              <ButtonFavoriteToggle category="brand" :slug="item.brandSlug" :disabled="true" class="no-outline absolute p-[10px] top-[15px] right-[15px] scale-[0.9]" />
              <img :src="replaceS3path(item.brandThumb)" :alt="stripslashes(item.brandName)" class="max-h-full" />
            </a>
          </li>
        </template>

        <template v-if="props.category === 'shop'">
          <li v-for="item in favorite.favorites" :key="item.shopID" class="relative w-1/2 p-[10px]">
            <a href="#" @click.prevent="openModal(item.shopID, 'shop')">
              <div class="flex items-center justify-center overflow-hidden w-full aspect-square rounded-[20px] mb-[10px]">
                <img class="h-full object-cover" :src="replaceS3path(item.shopImg1)" :alt="stripslashes(item.shopNameJ)" />
              </div>
              <div class="relative">
                <ButtonFavoriteToggle category="shop" :slug="item.shopSlug" :disabled="true" class="no-outline absolute top-[-10px] right-[-10px] p-[10px] scale-[0.9]" />
                <p class="leading-[1.4] font-semibold pr-[25px] text-[12px]" v-html="addBR(stripslashes(item.shopNameJ), 'A&Fカントリー ')" />
              </div>
            </a>
          </li>
        </template>
      </ul>
    </template>

    <ButtonRounded v-if="favorite.favorites.length" :text="`お気に入りを編集する`" class="mx-auto mt-[10px] mb-[70px] !w-[250px] font-medium" icon="arrow" url="#" @click.prevent="emit('change')" />
    <ButtonRounded v-else :text="`${props.categoryJ}を追加する`" class="mx-auto mt-[10px] mb-[70px] !w-[250px] font-medium" icon="arrow" url="#" @click.prevent="emit('change')" />

    <teleport to="#app">
      <transition name="fade"><Modal v-if="modal.open" class="modal" @close="modal.open = false" /></transition>
    </teleport>
  </div>
</template>
